module.exports = __webpack_public_path__ + "static/img/03.ca86c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/03.png
// module id = ocIF
// module chunks = 2